const ManageIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      className="h-4.5 w-4.5"
      aria-hidden="true"
    >
      <rect x="3.5" y="4" width="17" height="16" rx="3" />
      <path d="M8 9h8M8 13h5" />
    </svg>
  )
}

export default ManageIcon
